import {
  FETCH_COMMERCE_LINKS_LIST,
  FETCH_COMMERCE_LINKS_LIST_ERROR,
  CLEAR_FETCH_COMMERCE_LINKS_LIST,
  APPLY_COMMERCE_LINK_DRAG,
  APPLY_COMMERCE_LINK_DRAG_ERROR,
  CLEAR_COMMERCE_LINK_DRAG,
  ADD_COMMERCE_LINK_SUCCESS,
  ADD_COMMERCE_LINK_ERROR,
  CLEAR_ADD_COMMERCE_LINK,
  PATCH_COMMERCE_LINK_SUCCESS,
  PATCH_COMMERCE_LINK_ERROR,
  CLEAR_PATCH_COMMERCE_LINK,
  DELETE_COMMERCE_LINK_SUCCESS,
  DELETE_COMMERCE_LINK_ERROR,
  CLEAR_DELETE_COMMERCE_LINK,
  ADD_COMMERCE_AMOUNT_SUCCESS,
  ADD_COMMERCE_AMOUNT_ERROR,
  CLEAR_ADD_COMMERCE_AMOUNT,
  PATCH_COMMERCE_AMOUNT_SUCCESS,
  PATCH_COMMERCE_AMOUNT_ERROR,
  CLEAR_PATCH_COMMERCE_AMOUNT,
  DELETE_COMMERCE_AMOUNT_SUCCESS,
  DELETE_COMMERCE_AMOUNT_ERROR,
  CLEAR_DELETE_COMMERCE_AMOUNT,
  CREATE_STRIPE_ACCOUNT_SUCCESS,
  CREATE_STRIPE_ACCOUNT_ERROR,
  CLEAR_CREATE_STRIPE_ACCOUNT,
  CONNECT_STRIPE_ACCOUNT_SUCCESS,
  CONNECT_STRIPE_ACCOUNT_ERROR,
  CLEAR_CONNECT_STRIPE_ACCOUNT,
} from 'redux/commerce/types';

const initialState = {
  commerceLinksList: null,
  commerceLinksListError: null,
  commerceLinksDragSuccess: null,
  commerceLinksDragError: null,
  addCommerceLinkSuccess: null,
  addCommerceLinkError: null,
  patchCommerceLinkSuccess: null,
  patchCommerceLinkError: null,
  deleteCommerceLinkSuccess: null,
  deleteCommerceLinkError: null,
  addCommerceAmountSuccess: null,
  addCommerceAmountError: null,
  patchCommerceAmountSuccess: null,
  patchCommerceAmountError: null,
  deleteCommerceAmountSuccess: null,
  deleteCommerceAmountError: null,
  createStripeAccountSuccess: null,
  createStripeAccountError: null,
  connectStripeAccountSuccess: null,
  connectStripeAccountError: null,
};


export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMMERCE_LINKS_LIST:
      return {
        ...state,
        commerceLinksList: action.payload.data,
        commerceLinksListError: null,
      };
    case FETCH_COMMERCE_LINKS_LIST_ERROR:
      return {
        ...state,
        commerceLinksList: null,
        commerceLinksListError: action.payload.data,
      };
    case CLEAR_FETCH_COMMERCE_LINKS_LIST:
      return {
        ...state,
        commerceLinksList: null,
        commerceLinksListError: null,
      };
    case APPLY_COMMERCE_LINK_DRAG:
      return {
        ...state,
        commerceLinksDragSuccess: action.payload.data,
        commerceLinksDragError: null,
      };
    case APPLY_COMMERCE_LINK_DRAG_ERROR:
      return {
        ...state,
        commerceLinksDragSuccess: null,
        commerceLinksDragError: action.payload.data,
      };
    case CLEAR_COMMERCE_LINK_DRAG:
      return {
        ...state,
        commerceLinksDragSuccess: null,
        commerceLinksDragError: null,
      };
    case ADD_COMMERCE_LINK_SUCCESS:
      return {
        ...state,
        addCommerceLinkSuccess: action.payload.data,
        addCommerceLinkError: null,
      };
    case ADD_COMMERCE_LINK_ERROR:
      return {
        ...state,
        addCommerceLinkSuccess: null,
        addCommerceLinkError: action.payload.data,
      };
    case CLEAR_ADD_COMMERCE_LINK:
      return {
        ...state,
        addCommerceLinkSuccess: null,
        addCommerceLinkError: null,
      };
    case PATCH_COMMERCE_LINK_SUCCESS:
      return {
        ...state,
        patchCommerceLinkSuccess: action.payload.data,
        patchCommerceLinkError: null,
      };
    case PATCH_COMMERCE_LINK_ERROR:
      return {
        ...state,
        patchCommerceLinkSuccess: null,
        patchCommerceLinkError: action.payload.data,
      };
    case CLEAR_PATCH_COMMERCE_LINK:
      return {
        ...state,
        patchCommerceLinkSuccess: null,
        patchCommerceLinkError: null,
      };
    case DELETE_COMMERCE_LINK_SUCCESS:
      return {
        ...state,
        deleteCommerceLinkSuccess: action.payload.data,
        deleteCommerceLinkError: null,
      };
    case DELETE_COMMERCE_LINK_ERROR:
      return {
        ...state,
        deleteCommerceLinkSuccess: null,
        deleteCommerceLinkError: action.payload.data,
      };
    case CLEAR_DELETE_COMMERCE_LINK:
      return {
        ...state,
        deleteCommerceLinkSuccess: null,
        deleteCommerceLinkError: null,
      };
    case ADD_COMMERCE_AMOUNT_SUCCESS:
      return {
        ...state,
        addCommerceAmountSuccess: action.payload.data,
        addCommerceAmountError: null,
      };
    case ADD_COMMERCE_AMOUNT_ERROR:
      return {
        ...state,
        addCommerceAmountSuccess: null,
        addCommerceAmountError: action.payload.data,
      };
    case CLEAR_ADD_COMMERCE_AMOUNT:
      return {
        ...state,
        addCommerceAmountSuccess: null,
        addCommerceAmountError: null,
      };
    case PATCH_COMMERCE_AMOUNT_SUCCESS:
      return {
        ...state,
        patchCommerceAmountSuccess: action.payload.data,
        patchCommerceAmountError: null,
      };
    case PATCH_COMMERCE_AMOUNT_ERROR:
      return {
        ...state,
        patchCommerceAmountSuccess: null,
        patchCommerceAmountError: action.payload.data,
      };
    case CLEAR_PATCH_COMMERCE_AMOUNT:
      return {
        ...state,
        patchCommerceAmountSuccess: null,
        patchCommerceAmountError: null,
      };
    case DELETE_COMMERCE_AMOUNT_SUCCESS:
      return {
        ...state,
        deleteCommerceAmountSuccess: action.payload.data,
        deleteCommerceAmountError: null,
      };
    case DELETE_COMMERCE_AMOUNT_ERROR:
      return {
        ...state,
        deleteCommerceAmountSuccess: null,
        deleteCommerceAmountError: action.payload.data,
      };
    case CLEAR_DELETE_COMMERCE_AMOUNT:
      return {
        ...state,
        deleteCommerceAmountSuccess: null,
        deleteCommerceAmountError: null,
      };
    case CREATE_STRIPE_ACCOUNT_SUCCESS:
      return {
        ...state,
        createStripeAccountSuccess: action.payload.data,
        createStripeAccountError: null,
      };
    case CREATE_STRIPE_ACCOUNT_ERROR:
      return {
        ...state,
        createStripeAccountSuccess: null,
        createStripeAccountError: action.payload.data,
      };
    case CLEAR_CREATE_STRIPE_ACCOUNT:
      return {
        ...state,
        createStripeAccountSuccess: null,
        createStripeAccountError: null,
      };
    case CONNECT_STRIPE_ACCOUNT_SUCCESS:
      return {
        ...state,
        connectStripeAccountSuccess: action.payload.data,
        connectStripeAccountError: null,
      };
    case CONNECT_STRIPE_ACCOUNT_ERROR:
      return {
        ...state,
        connectStripeAccountSuccess: null,
        connectStripeAccountError: action.payload.data,
      };
    case CLEAR_CONNECT_STRIPE_ACCOUNT:
      return {
        ...state,
        connectStripeAccountSuccess: null,
        connectStripeAccountError: null,
      };
    default:
      return state;
  }
};
